var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 16,
    viewBox: "0 0 48 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4375 0.1875V15.8125H44.3125L41.1875 6.4375V15.8125H38.0625V0.1875H41.1875L44.3125 9.5625V0.1875H47.4375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3336 15.8125H28.1664C27.476 15.8117 26.8142 15.5371 26.326 15.049C25.8379 14.5608 25.5633 13.899 25.5625 13.2086V2.79141C25.5633 2.10105 25.8379 1.43919 26.326 0.951034C26.8142 0.462877 27.476 0.188286 28.1664 0.1875H32.3336C33.024 0.188286 33.6858 0.462877 34.174 0.951034C34.6621 1.43919 34.9367 2.10105 34.9375 2.79141V13.2086C34.9367 13.899 34.6621 14.5608 34.174 15.049C33.6858 15.5371 33.024 15.8117 32.3336 15.8125ZM28.6875 12.6875H31.8125V3.3125H28.6875V12.6875Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8336 15.8125H13.0625V12.6875H19.3125V9.5625H16.1875C15.359 9.56167 14.5646 9.23217 13.9787 8.6463C13.3928 8.06042 13.0633 7.26605 13.0625 6.4375V2.79141C13.0633 2.10105 13.3379 1.43919 13.826 0.951034C14.3142 0.462877 14.976 0.188286 15.6664 0.1875H22.4375V3.3125H16.1875V6.4375H19.3125C20.141 6.43833 20.9354 6.76783 21.5213 7.35371C22.1072 7.93958 22.4367 8.73395 22.4375 9.5625V13.2086C22.4367 13.899 22.1621 14.5608 21.674 15.049C21.1858 15.5371 20.524 15.8117 19.8336 15.8125Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33359 15.8125H3.16641C2.47605 15.8117 1.81419 15.5371 1.32603 15.049C0.837877 14.5608 0.563286 13.899 0.5625 13.2086V9.5625H3.6875V12.6875H6.8125V0.1875H9.9375V13.2086C9.93671 13.899 9.66212 14.5608 9.17397 15.049C8.68581 15.5371 8.02395 15.8117 7.33359 15.8125V15.8125Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJson);
export default __webpack_public_path__ + "static/media/json.76d9b1a606a954186e8d90eec71830ca.svg";
export { ForwardRef as ReactComponent };